import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import isHotkey from 'is-hotkey';
import { ReactEditor, useSlate } from 'slate-react'
import { jsx } from 'slate-hyperscript'
import sanitizeHtml from 'sanitize-html';


import BaseElement from './BaseElement';
import { serializeHTML } from '../index'
import { parseDate, noop } from 'utils';

export function renderHeaderElement(params) {
  return (props) => {

    if (props.element.type === 'header') { 
      return (
          <HeaderElement {...props} {...params} />
      );
    }
  
    return undefined;

  }
}



export const HeaderPlugin = (params) => ({
  renderElement: renderHeaderElement(params),
  renderElementDeps: [params.contract],
  voidTypes: ['header']
});

export default function HeaderElement({ contract: doc = {}, attributes, index, element, children, ...props }) {
  const { t } = useTranslation()
  const html = useMemo(() => sanitizeHtml(serializeHTML( { nodes: getHeader({doc}), contract: doc })), [doc])
  
  return (
    <BaseElement element={element} type="header" contract={doc} {...props} contentStyle={{textAlign: 'justify', lineHeight: 1.5}}>
      {({ isEmpty }) => (
        <React.Fragment>
          <div {...attributes} contentEditable={false} >
            <div dangerouslySetInnerHTML={{__html: html }} />
            <span>
                {children}
            </span>
          </div>
        </React.Fragment>
      )}
    </BaseElement>
  )
}


export function getHeader({ doc = {} }) {
    const {language = 'es', participants = [], type, createdAt } = doc

    switch(language.toLowerCase()) {
        case 'es': 
            return [
                { text: type?.name ?? '', bold: true, lineHeight: '1.5' },
                { text: ' QUE CELEBRAN ', lineHeight: '1.5' },
                ...participants.reduce((arr, participant, index) => {
                    if (participant.obligation === 'individual') {
                        arr.push({ text: `${participant?.name ?? ''} ${participant?.last_name ?? ''}`, bold: true, lineHeight: '1.5' })
                        arr.push({ text: ', A QUIEN EN LO SUCESIVO SE LE DENOMINARA COMO ', lineHeight: '1.5' })
                        arr.push({ text: `"${participant?.label ?? ''}"`, bold: true, lineHeight: '1.5' })
                    } else if (participant.obligation === 'legal') {
                        arr.push({ text: `${participant?.name ?? ''}`, bold: true, lineHeight: '1.5' })
                        arr.push({ text: ', REPRESENTADA EN ESTE ACTO POR ', lineHeight: '1.5' })
                        arr.push({ text: `${participant?.representative ?? ''}`, bold: true, lineHeight: '1.5' })
                        arr.push({ text: ', A QUIEN EN LO SUCESIVO SE LE DENOMINARA COMO ', lineHeight: '1.5' })
                        arr.push({ text: `"${participant?.label ?? ''}"`, bold: true, lineHeight: '1.5' })
                    }
                        
                    if (index !== participants.length - 1) arr.push({ text: ' Y ', lineHeight: '1.5' })
                    return arr
                }, []),
                {text: '; AL TENOR DE LAS SIGUIENTES DECLARACIONES Y CLÁUSULAS:', lineHeight: '1.5' }
            ]
        case 'en':
        default:
            return [
                { text: 'THIS SERVICE AGREEMENT (THE “AGREEMENT”) SETS FORTH TERMS UNDER WHICH ', lineHeight: '1.5' },
                { text: `${participants[0].name} ("${participants[0].label }")`, bold: true, lineHeight: '1.5' },
                { text: ' SHALL PROVIDE SERVICES TO ', lineHeight: '1.5' },
                { text: `${participants[1]?.name ?? ''} ("${participants[1]?.label ?? '' }")`, bold: true, lineHeight: '1.5' },
                { text: '. THIS AGREEMENT IS EFFECTIVE AS OF THIS ', lineHeight: '1.5' }, 
                { text: parseDate(createdAt,'do'), bold: true, lineHeight: '1.5' }, 
                { text: ' DAY OF ' },
                { text: parseDate(createdAt,'MMMM'), bold: true, lineHeight: '1.5'},
                { text: ', ' },
                { text: parseDate(createdAt,'yyyy'), bold: true, lineHeight: '1.5'},
                {text: '.' }
            ]
            
    }
}